"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events */
const react_1 = require("react");
const noop_1 = __importDefault(require("lodash/noop"));
const classnames_1 = __importDefault(require("classnames"));
const useMergeRefs_1 = __importDefault(require("../../../hooks/useMergeRefs"));
const Icon_1 = __importDefault(require("../../Icon/Icon"));
require("./Tab.scss");
const Tab = (0, react_1.forwardRef)(({ className, id, value = 0, disabled = false, active = false, focus = false, onClick = noop_1.default, icon, iconType, iconSide = "left", children }, ref) => {
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    function renderIconAndChildren() {
        if (!icon)
            return children;
        const iconElement = ((0, jsx_runtime_1.jsx)(Icon_1.default, { clickable: false, ariaHidden: true, iconType: iconType, icon: icon, className: (0, classnames_1.default)("tab-icon", iconSide), iconSize: 18, ignoreFocusStyle: true }));
        if (iconSide === "left") {
            return [iconElement, ...children];
        }
        return [...children, iconElement];
    }
    return ((0, jsx_runtime_1.jsx)("li", Object.assign({ ref: mergedRef, className: (0, classnames_1.default)("tab--wrapper", className, {
            active,
            disabled,
            "tab-focus-visible-inset": focus
        }), id: id, role: "tab", "aria-selected": active, "aria-disabled": disabled }, { children: (0, jsx_runtime_1.jsx)("a", Object.assign({ className: "tab-inner", onClick: () => !disabled && onClick(value) }, { children: renderIconAndChildren() })) }), id));
});
exports.default = Tab;
